module.exports = __webpack_public_path__ + "img/confirmStatusBtn.d5e08be2.svg";